import { updateSpellingDecoration } from './spelling-decorations';
import { addSelectedSpellingDecoration, removeSelectedSpellingDecoration } from './spelling-selected-decoration';
export var SpellingAndGrammarDecorations = {
  SPELLING_ERROR: 'spellingError',
  SPELLING_ERROR_SELECTED: 'spellingErrorSelected',
  SUGGESTION: 'suggestion'
};
var composeDecorations = function composeDecorations(transformers) {
  return function (_ref) {
    var decorationSet = _ref.decorationSet,
      tr = _ref.tr,
      pluginState = _ref.pluginState;
    return transformers.reduce(function (decorationSet, transform) {
      return transform({
        decorationSet: decorationSet,
        tr: tr,
        pluginState: pluginState
      });
    }, decorationSet);
  };
};
export var filterDecorationByKey = function filterDecorationByKey(key, decorationSet) {
  return decorationSet.find(undefined, undefined, function (spec) {
    return spec.key.indexOf(key) > -1;
  });
};
export var regenerateSelectedSpellingDecorations = function regenerateSelectedSpellingDecorations(params) {
  return composeDecorations([removeSelectedSpellingDecoration, addSelectedSpellingDecoration])(params);
};
export var regenerateAllDecorations = function regenerateAllDecorations(params) {
  return composeDecorations([removeSelectedSpellingDecoration, updateSpellingDecoration, addSelectedSpellingDecoration])(params);
};